<template>
  <div class="DataTableDisplay">
    <DataTable
      :data="getData"
      :headers="headers"
      withPagination
      @rowClick="navigateToItem"
      ><template slot-scope="{ row, header }">
        <TableField :data="row" :header="header" />
      </template>
    </DataTable>
  </div>
</template>
<script>
import { DataTable } from 'daas-components';

import headers from '@/components/DataTable/headers';

import TableField from './TableField';

export default {
  name: 'DataTableDisplay',
  data() {
    return {
      headers,
      dataValue: {},
    };
  },
  components: {
    DataTable,
    TableField,
  },
  computed: {
    getData() {
      return this.data.map(column => ({
        name: this.getTotalValue(column, 'name'),
        sector: this.getTotalValue(column, 'sector'),
        amount: this.getTotalValue(column, 'amount'),
        investment: this.getTotalValue(column, 'investment'),
        activados: this.getTotalValue(column, 'activated'),
        pausados: this.getTotalValue(column, 'paused'),
        pendientes: this.getTotalValue(column, 'pending'),
        id: column.id,
      }));
    },
  },
  methods: {
    getTotalValue(data, key, defaultValue = 'N/A') {
      if (!data[key] || data[key] === null) return defaultValue;
      return data[key];
    },
    navigateToItem(event, { id }) {
      this.$emit('click', event, id)
    },
  },
  props: {
    data: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.DataTableDisplay {
  @include basicCard();
  padding: rem(20);
  margin: rem(10);
  margin-left: rem(300);
  margin-right: rem(300);
  max-width: 100%;
  .DataTable {
    &__Headers {
      margin-left: rem(10);
    }
  }
}
</style>
